import React, { useEffect, useMemo } from 'react';
import FileSaver from 'file-saver';
import { RootState, useSelector } from 'src/store';
import { trackImageDisplayed } from 'src/Utils/analytics';

export const ImagePreview = () => {
  const { renderState, fileBlob, isPreviewOnly, actualFormat } = useSelector((state: RootState) => state.renderRequest);
  const urlCreator = window.URL || window.webkitURL;

  useEffect(() => {
    if (renderState === 'complete' && fileBlob) {
      trackImageDisplayed({ file_format: fileBlob.type, is_preview_only: isPreviewOnly });
    }
  }, [renderState, fileBlob, isPreviewOnly]);

  const objectUrl = useMemo(
    () => (fileBlob ? urlCreator.createObjectURL(fileBlob) : ''),
    [fileBlob]
  );

  const isPdf = (fileBlob?.type ?? '').includes('pdf');
  const isRendered = renderState === 'complete' && !!fileBlob;

  const handleDownload = () => {
    if (fileBlob && actualFormat) FileSaver(fileBlob, `ideogram.${actualFormat}`);
  };

  return (
    <div className="canvas-wrap">
      <div className="canvas-topbar">
        <button
          type="button"
          className="btn-download"
          disabled={!isRendered}
          onClick={handleDownload}
        >
          ↓ Download
        </button>
      </div>

      <div className={`canvas-body${isRendered ? ' rendered' : ''}`}>
        {renderState === 'running' ? (
          <div className="canvas-generating">Rendering ideogram…</div>
        ) : isRendered ? (
          <div className="karyotype-svg-wrap">
            {isPdf
              ? <iframe src={`${objectUrl}#zoom=60`} title="Ideogram PDF" />
              : <img src={objectUrl} alt="Rendered ideogram" />
            }
          </div>
        ) : (
          <div className="empty-state">
            <svg className="chrom-art" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="70" cy="25" rx="14" ry="22" fill="currentColor" />
              <rect x="63" y="47" width="14" height="46" rx="5" fill="currentColor" />
              <ellipse cx="70" cy="115" rx="14" ry="22" fill="currentColor" />
            </svg>
            <h2>Your ideogram will appear here</h2>
            <p>Upload the required files and click Generate to render a karyotype ideogram.</p>
            <div className="steps-row">
              <div className="step"><strong>Step 1</strong>Upload a cytoband or band file</div>
              <div className="step"><strong>Step 2</strong>Upload a sample file</div>
              <div className="step"><strong>Step 3</strong>Click Generate Ideogram</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
